import ExportButton from '../../components/ExportButton';
import { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../styles/Services.css';
import { useWorkOrdersListingExport } from './useWorkOrdersListingExport';
import { RiDeleteBinLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs';
import AssetCard, { getWorkOrderAssetType, getWorkOrderAssetTypeLabel } from '../../components/AssetCard';
import CustomModal from '../../components/CustomModal';
import MultiLineText from '../../components/MultiLineText';
import NewTableComponent from '../../components/NewTableComponent';
import Notification from '../../components/Notification';
import TableHoverCard from '../../components/TableHoverCard';
import TablePopover from '../../components/TablePopover';
import UserAvatar from '../../components/UserAvatar';
import UserProfileCard from '../../components/UserProfileCard';
import Button from '../../components/button';
import { getServiceEntryDropdown } from '../../store/Slices/IssuesSlice';
import { fetchNotificationsData } from '../../store/Slices/NotificationSlice';
import { getUserDropdown } from '../../store/Slices/UserSlice';
import { deleteWorkOrder, fetchWorkOrder, getVendorsDropdown, updateRepairPriorityApi, updateVendorApi, updateWorkOrderAssigneeApi, updateWorkOrderStatusApi, workOrderLinkServiceEntry } from "../../store/Slices/WorkOrderSlice";
import '../../styles/WorkOrder.css';
import { approvalStatusOptions, repairPriorityOptions } from '../../utils/Dropdowns';
import { hasPermission } from '../../utils/helper';
import { AppMainModules, MaintinaceSubModules, WorkOrdersPermission } from '../../utils/app-constant';
import { approvedIcon, closedIcon, inProgressIcon, linkedIcon, openIcon, pendingIcon, plusIcon, resolvedIcon, scheduledIcon, unscheduledIcon } from '../../utils/svgs';
import { errorNotify, successNotify } from '../../utils/toast';
import PermissionWrapper from '../../components/PermissionWrapper';
import CreateWorkOrder from './CreateWorkOrder';
import WorkOrdersChart from './WorkOrdersChart';

const WorkOrders = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { createLinkIssueLoading } = useSelector((state) => state.issues)

    const { workOrdersData, workOrdersLoading, workOrderPdfExportLoading,
        workOrderExcelExportLoading, deleteWorkOrderLoading,
        getVendorsDropdownData, updateVendorLoading, updateRepairPriorityLoading,
        updateWorkOrderAssigneeLoading, updateWorkOrderStatusLoading } = useSelector((state) => state.workOrder)

    const { userDropdownData } = useSelector((state) => state.users)

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchText, setSearchText] = useState('');

    const [deleteUserPopup, setDeleteUserPopup] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(null);

    const [searchFilters, setSearchFilters] = useState(null);

    const {
        hasActiveFilters,
        exportLoading,
        pdfExportLoading,
        excelExportLoading,
        handleExportPdf,
        handleExportExcel,
    } = useWorkOrdersListingExport(searchText, searchFilters);
    const [showCreateIssuePopup, setShowCreateIssuePopup] = useState(false);

    const [priorityPopup, setPriorityPopup] = useState({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
    const [sePopup, setSePopup] = useState({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
    const [selectedSE, setSelectedSE] = useState({});
    const [hoveredUser, setHoveredUser] = useState({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false });
    const [assigneeDropdown, setAssigneeDropdown] = useState({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
    const [vendorDropdown, setVendorDropdown] = useState({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
    const [statusPopup, setStatusPopup] = useState({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
    const [tableLoading, setTableLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);

    const canCreate = hasPermission({ permissionSlug: WorkOrdersPermission.Create, menuSlug: MaintinaceSubModules.WorkOrders, moduleSlug: AppMainModules.maintenance });
    const canDelete = hasPermission({ permissionSlug: WorkOrdersPermission.Delete, menuSlug: MaintinaceSubModules.WorkOrders, moduleSlug: AppMainModules.maintenance });
    const canView = hasPermission({ permissionSlug: WorkOrdersPermission.View, menuSlug: MaintinaceSubModules.WorkOrders, moduleSlug: AppMainModules.maintenance });
    const canEdit = hasPermission({ permissionSlug: WorkOrdersPermission.Update, menuSlug: MaintinaceSubModules.WorkOrders, moduleSlug: AppMainModules.maintenance });
    const canExport = hasPermission({ permissionSlug: WorkOrdersPermission.Export, menuSlug: MaintinaceSubModules.WorkOrders, moduleSlug: AppMainModules.maintenance });

    const popupRef = useRef();
    const sePopupRef = useRef();
    const assigneeDropdownRef = useRef();
    const vendorDropdownRef = useRef();
    const statusPopupRef = useRef();
    const hoverTimeoutRef = useRef(null);

    const divRef = useRef(null);

    useEffect(() => {
        dispatch(getServiceEntryDropdown())
        dispatch(getUserDropdown());
        dispatch(getVendorsDropdown())
        dispatch(fetchNotificationsData());
    }, [])

    useEffect(() => {
        function handleClickOutside(event) {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setPriorityPopup({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
            }
        }
        if (priorityPopup.open) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [priorityPopup.open]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sePopupRef.current && !sePopupRef.current.contains(event.target)) {
                setSePopup({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
                setSelectedSE({});
            }
        }
        if (sePopup.open) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sePopup.open]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (assigneeDropdownRef.current && !assigneeDropdownRef.current.contains(event.target)) {
                setAssigneeDropdown({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
            }
        }
        if (assigneeDropdown.open) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [assigneeDropdown.open]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (vendorDropdownRef.current && !vendorDropdownRef.current.contains(event.target)) {
                setVendorDropdown({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
            }
        }
        if (vendorDropdown.open) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [vendorDropdown.open]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (statusPopupRef.current && !statusPopupRef.current.contains(event.target)) {
                setStatusPopup({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
            }
        }
        if (statusPopup.open) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [statusPopup.open]);

    const handleAssigneeClick = (e, row) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setAssigneeDropdown({
            open: true,
            rowId: row.id,
            anchorPos: { x: rect.right + 8, y: rect.top }
        });
    };

    const handleVendorClick = (e, row) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setVendorDropdown({
            open: true,
            rowId: row.id,
            anchorPos: { x: rect.right + 8, y: rect.top }
        });
    };

    const handleAssigneeChange = async (userId, row) => {
        setTableLoading(true);
        try {
            await dispatch(updateWorkOrderAssigneeApi({ work_order_id: row.id, assignee_id: userId })).unwrap();
            await dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                search_text: searchText,
                searchFilters: searchFilters
            }));
            successNotify('Assignee changed successfully');
            setAssigneeDropdown({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
        } catch (error) {
            errorNotify(error);
        } finally {
            setTableLoading(false);
        }
    };

    const handleVendorChange = async (userId, row) => {
        setTableLoading(true);
        try {
            await dispatch(updateVendorApi({ work_order_id: row.id, vendor_id: userId })).unwrap();
            await dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                search_text: searchText,
                searchFilters: searchFilters
            }));
            successNotify('Vendor updated successfully');
            setVendorDropdown({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
        } catch (error) {
            errorNotify(error);
        } finally {
            setTableLoading(false);
        }
    };

    const handleStatusSelect = async (status, row) => {
        setTableLoading(true);
        try {
            await dispatch(updateWorkOrderStatusApi({ status, work_order_id: row.id })).unwrap();
            await dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                search_text: searchText,
                searchFilters: searchFilters
            }));
            setStatusPopup({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
            successNotify('Status updated successfully');
        } catch (err) {
            errorNotify(err);
        } finally {
            setTableLoading(false);
        }
    };

    useEffect(() => {
        if (searchText.length > 0 || searchFilters) {
            dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                search_text: searchText,
                searchFilters: searchFilters
            }));
        }
        else {
            dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
            }));
        }
    }, [searchText, currentPage, limit, searchFilters]);

    const commonColumns = {
        checked: true,
        disabled: true,
        hide: false,
        exportColumn: true,
        sortable: false,
    }

    const columns = [
        {
            ...commonColumns,
            name: "Word Order No.",
            key: "work_order_id",
            selector: (row) => (
                <span
                    className="hyperlink"
                    onClick={canView ? () => navigate(`/work-orders/work-order-details/${row?.id}`) : undefined}
                    style={{ cursor: canView ? 'pointer' : 'default' }}
                >
                    {row?.work_order_id}
                </span>
            ),
            minWidth: "140px",
            tableColumn: false,
            filterName: "workOrderFilter",
            type: "text",
        },
        {
            ...commonColumns,
            name: "Assets Type",
            key: "asset_type",
            selector: (row, index) => {
                const assetType = getWorkOrderAssetType(row);
                const assetTypeLabel = getWorkOrderAssetTypeLabel(row) || '-';
                return (
                    <div
                        className="hyperlink"
                        onMouseEnter={assetType ? e => handleUserMouseEnter(e, row, assetType) : undefined}
                        onMouseLeave={handleUserMouseLeave}
                        onClick={assetType ? e => handleUserClick(e, row, assetType) : undefined}
                        style={{ display: "inline-block", overflow: "visible", textTransform: "capitalize" }}
                    >
                        {assetTypeLabel}
                        <TableHoverCard
                            show={hoveredUser.show && hoveredUser.rowId === row.id && hoveredUser.type === assetType}
                            index={index}
                            placement="right"
                            cardWidth={320}
                            popupHeight={336}
                            offsetX={12}
                            anchorRect={hoveredUser.anchorPos}
                            portalToBody
                            viewportPadding={16}
                            zIndex={10000}
                            onMouseEnter={handleCardMouseEnter}
                            onMouseLeave={handleCardMouseLeave}
                        >
                            {hoveredUser.show && hoveredUser.rowId === row.id && hoveredUser.type === assetType && (
                                <AssetCard workOrder={row} />
                            )}
                        </TableHoverCard>
                    </div>
                )
            },
            minWidth: "100px",
            tableColumn: true,
            filterName: "assetTypeFilter",
            type: "dropdown",
            options: [
                { label: "Vehicle", value: "vehicle" },
                { label: "Equipment", value: "equipment" },
                { label: "Tyre", value: "tyre" },
            ],
        },
        {
            ...commonColumns,
            name: "Repair Priority Class",
            key: "repair_class",
            tableColumn: true,
            filterName: "repairClassFilter",
            type: "text",
            minWidth: "120px",
            selector: (row, index) => (
                <div style={{ display: "inline-block", overflow: "visible" }}>
                    <div
                        className={`${row?.repair_class}`}
                        style={{ cursor: canEdit ? "pointer" : "default" }}
                        onClick={canEdit ? e => handlePriorityClick(e, row) : undefined}
                    >
                        {
                            row?.repair_class === 'unscheduled' ? unscheduledIcon : scheduledIcon
                        }
                        {row?.repair_class}

                        {
                            priorityPopup.open && priorityPopup.rowId === row.id &&
                            <PriorityPopup row={row} onSelect={handlePrioritySelect} index={index} />
                        }
                    </div>
                </div>
            ),
        },
        {
            ...commonColumns,
            name: "Linked Service Entries",
            key: "service_entry",
            tableColumn: false,
            filterName: "servicesFilter",
            type: "text",
            minWidth: "190px",
            selector: (row, index) => {
                const serviceItems = row?.services || [];

                if (serviceItems.length === 0) {
                    return (
                        <div style={{ display: "inline-block", overflow: "visible" }} ref={divRef} id="yourDiv">
                            <button className='add_se_btn' style={{ cursor: canEdit ? 'pointer' : 'default', opacity: canEdit ? 1 : 0.6 }} onClick={canEdit ? e => handleSEClick(e, row) : undefined}>{linkedIcon} Link</button>
                            {sePopup.open && sePopup.rowId === row.id &&
                                <AddSEPopup
                                    selected={selectedSE[row.id] || []}
                                    onCheck={handleSECheckbox}
                                    onDone={handleSEPopupDone}
                                    row={row}
                                    index={index}
                                />
                            }
                        </div>
                    );
                }

                if (serviceItems.length === 1) {
                    return (
                        <span className="service-task">
                            <MultiLineText text={serviceItems[0]?.service_id} maxWidth={"90px"} />
                        </span>
                    );
                }

                const firstItem = serviceItems[0]?.service_id || 'N/A';
                const remainingCount = serviceItems.length - 1;

                return (
                    <div className="service-tasks-container">
                        <span className="first-task">
                            <MultiLineText text={firstItem} maxWidth={"90px"} />
                        </span>

                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    <div>
                                        {serviceItems.slice(1).map((item, idx) => (
                                            <div key={idx} className='tooltip_item'>{item?.service_id}</div>
                                        ))}
                                    </div>
                                </Tooltip>
                            }
                        >
                            <span className="additional-tasks">+{remainingCount}</span>
                        </OverlayTrigger>

                    </div>
                );
            },
        },
        {
            ...commonColumns,
            name: "Financial Approval",
            key: "finance_status",
            modifyData: (row) => row?.finance_status,
            tableColumn: false,
            filterName: "financeStatusFilter",
            type: "text",
            minWidth: "120px",
            selector: (row) => (
                <div className={`${row?.finance_status}`}>
                    {row?.finance_status === 'pending' && pendingIcon}
                    {row?.finance_status === 'approved' && approvedIcon}
                    {row?.finance_status === 'rejected' && closedIcon}
                    {row?.finance_status}
                </div>
            ),
        },
        {
            ...commonColumns,
            name: "Operations Approval",
            key: "operation_status",
            modifyData: (row) => row?.operation_status,
            tableColumn: true,
            filterName: "operationStatusFilter",
            type: "text",
            minWidth: "120px",
            selector: (row) => (
                <div className={`priority ${row?.operation_status}`}>
                    {row?.operation_status === 'pending' && pendingIcon}
                    {row?.operation_status === 'approved' && approvedIcon}
                    {row?.operation_status === 'rejected' && closedIcon}
                    {row?.operation_status}
                </div>
            ),
        },
        {
            ...commonColumns,
            name: "Issue By",
            key: "issue_by",
            selector: (row, index) => {
                return (
                    <div
                        onMouseEnter={e => handleUserMouseEnter(e, row, "reporter")}
                        onMouseLeave={handleUserMouseLeave}
                        style={{ display: "inline-block", overflow: "visible", textTransform: "capitalize" }}
                    >

                        <div className='d-flex align-items-center' style={{ cursor: "pointer" }}>
                            <UserAvatar username={row?.issue_by?.username} image={row?.issue_by?.image} marginRight="7px" />
                            <span className="hyperlink">{row?.issue_by?.username}</span>
                        </div>

                        <TableHoverCard
                            show={hoveredUser.show && hoveredUser.rowId === row.id && hoveredUser.type === "reporter"}
                            index={index}
                            placement="left"
                            cardWidth={380}
                            popupHeight={180}
                            offsetX={5}
                            anchorRect={hoveredUser.anchorPos}
                            portalToBody
                            viewportPadding={16}
                            zIndex={10000}
                            onMouseEnter={handleCardMouseEnter}
                            onMouseLeave={handleCardMouseLeave}
                        >
                            {hoveredUser.show && hoveredUser.rowId === row.id && hoveredUser.type === "reporter" && (
                                <UserProfileCard row={row?.issue_by} index={index} showModal={showModal} setShowModal={setShowModal}
                                    handleCardMouseEnter={handleCardMouseEnter} handleCardMouseLeave={handleCardMouseLeave}
                                    closeHoverCard={() => setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false })}
                                />
                            )}
                        </TableHoverCard>
                    </div>
                )
            },
            tableColumn: true,
            filterName: "issueByFilter",
            type: "text",
            minWidth: "230px",
        },
        {
            ...commonColumns,
            name: "Assignee To",
            key: "assignee",
            selector: (row, index) => {
                const windowHeight = document.documentElement.clientHeight;
                const assigneePopupHeight = 150;

                const assigneeAvailableSpaceAbove = index * assigneePopupHeight;
                const assigneeAvailableSpaceBelow = windowHeight - (assigneeAvailableSpaceAbove + assigneePopupHeight);

                let assigneeStyle = {};
                if (assigneeAvailableSpaceBelow > assigneeAvailableSpaceAbove) {
                    assigneeStyle = { top: "35px" }
                } else {
                    assigneeStyle = { bottom: "35px" }
                }

                return (
                    <div
                        onMouseEnter={e => handleUserMouseEnter(e, row, "assignee")}
                        onMouseLeave={handleUserMouseLeave}
                        style={{ display: "inline-block", overflow: "visible", textTransform: "capitalize" }}
                    >
                        <div onClick={canEdit ? e => handleAssigneeClick(e, row) : undefined} className='d-flex align-items-center' style={{ cursor: canEdit ? "pointer" : "default" }}>
                            <UserAvatar username={row?.assignee?.username} image={row?.assignee?.image} marginRight="7px" />
                            <span className="hyperlink">{row?.assignee?.username}</span>
                        </div>
                        <TableHoverCard
                            show={hoveredUser.show && hoveredUser.rowId === row.id && hoveredUser.type === "assignee"}
                            index={index}
                            placement="left"
                            cardWidth={380}
                            popupHeight={180}
                            offsetX={5}
                            anchorRect={hoveredUser.anchorPos}
                            portalToBody
                            viewportPadding={16}
                            zIndex={10000}
                            onMouseEnter={handleCardMouseEnter}
                            onMouseLeave={handleCardMouseLeave}
                        >
                            {hoveredUser.show && hoveredUser.rowId === row.id && hoveredUser.type === "assignee" && (
                                <UserProfileCard row={row?.assignee} index={index} showModal={showModal} setShowModal={setShowModal}
                                    handleCardMouseEnter={handleCardMouseEnter} handleCardMouseLeave={handleCardMouseLeave}
                                    closeHoverCard={() => setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false })}
                                />
                            )}
                        </TableHoverCard>

                        {assigneeDropdown.open && assigneeDropdown.rowId === row.id &&
                            <div
                                style={{
                                    position: "absolute",
                                    left: "0px",
                                    zIndex: 4,
                                    background: "transparent",
                                    ...assigneeStyle
                                }}
                                onMouseEnter={() => setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false })}
                            >
                                <AssigneeDropdown
                                    users={userDropdownData || []}
                                    onSelect={handleAssigneeChange}
                                    row={row}
                                    dropdownRef={assigneeDropdownRef}
                                />
                            </div>
                        }
                    </div>
                )
            },
            tableColumn: true,
            filterName: "assigneeFilter",
            type: "text",
            minWidth: "230px",
        },
        {
            ...commonColumns,
            name: "Status",
            key: "status",
            selector: (row, index) => (
                <div style={{ display: "inline-block", overflow: "visible" }}>
                    <div
                        className={`status ${row?.status}`}
                        style={{ cursor: canEdit ? "pointer" : "default", textTransform: "capitalize" }}
                        onClick={canEdit ? (row?.status === "in_progress" || row?.status === "approved" ? e => handleStatusClick(e, row) : null) : undefined}
                    >
                        <div className='d-flex align-items-center gap-1'>
                            {row?.status === "in_progress" ? inProgressIcon : row?.status === "pending" ? pendingIcon : row?.status === "open" ? openIcon : row?.status === "closed" ? closedIcon : row?.status === "resolved" ? resolvedIcon : row?.status === "approved" ? approvedIcon : row?.status === "completed" ? resolvedIcon : row?.status === "in_progress" ? inProgressIcon : null}
                            {row?.status === "in_progress" ? "In Progress" : row?.status}
                        </div>

                        {statusPopup.open && statusPopup.rowId === row.id &&
                            <StatusPopup row={row} onSelect={handleStatusSelect} index={index} />
                        }
                    </div>
                </div>

            ),
            tableColumn: true,
            filterName: "statusFilter",
            component: "wordOrder",
            type: "text",
            minWidth: "120px",
        },
        {
            ...commonColumns,
            name: "Created On",
            key: "created_at",
            selector: (row) => "" + new Date(row?.created_at).toLocaleDateString(),
            // minWidth: "140px",
            tableColumn: false,
            filterName: "createdOnFilter",
            type: "date",
        },
        {
            ...commonColumns,
            name: "Expected Completion Date",
            key: "expected_completion_at",
            selector: (row) => "" + new Date(row?.expected_completion_at).toLocaleDateString(),
            // minWidth: "140px",
            tableColumn: true,
            filterName: "expectedCompletionAtFilter",
            type: "date",
        },
        {
            ...commonColumns,
            name: "Scheduled Completion Date",
            key: "scheduled_start_at",
            selector: (row) => "" + new Date(row?.scheduled_start_at).toLocaleDateString(),
            // minWidth: "140px",
            tableColumn: true,
            filterName: "scheduledStartAtFilter",
            type: "date",
        },
        {
            ...commonColumns,
            name: "Vendor",
            key: "vendor",
            selector: (row, index) => {
                const windowHeight = document.documentElement.clientHeight;
                const popupHeight = 180;

                const availableSpaceAbove = index * popupHeight;
                const availableSpaceBelow = windowHeight - (availableSpaceAbove + popupHeight);

                let assigneeStyle = {}
                if (availableSpaceBelow > availableSpaceAbove) {
                    assigneeStyle = { top: "22px" }
                } else {
                    assigneeStyle = { bottom: "20px" }
                }

                return (
                    <div
                        className="hyperlink"
                        // onMouseEnter={e => handleUserMouseEnter(e, row, "assignee")}
                        // onMouseLeave={handleUserMouseLeave}
                        style={{ display: "inline-block", overflow: "visible", textTransform: "capitalize" }}
                    >
                        <div onClick={canEdit ? e => handleVendorClick(e, row) : undefined} style={{ cursor: canEdit ? 'pointer' : 'default' }}>
                            {row?.vendor?.name || 'N/A'}
                        </div>
                        {vendorDropdown.open && vendorDropdown.rowId === row.id &&
                            <div
                                style={{
                                    position: "absolute",
                                    left: "0px",
                                    zIndex: 4,
                                    background: "transparent",
                                    ...assigneeStyle
                                }}
                            >
                                <UserDropdown
                                    users={getVendorsDropdownData || []}
                                    onSelect={handleVendorChange}
                                    row={row}
                                    dropdownRef={vendorDropdownRef}
                                />
                            </div>
                        }
                    </div>
                )
            },
            tableColumn: true,
            filterName: "vendorFilter",
            type: "text",
            minWidth: "200px",
        },
        {
            ...commonColumns,
            name: "Invoice No.",
            key: "invoice_no",
            selector: (row) => row?.invoice_no || "-",
            // minWidth: "140px",
            tableColumn: false,
            filterName: "invoiceNoFilter",
            type: "text",
        },
        {
            ...commonColumns,
            name: "Total Cost (PKR)",
            key: "complete_total_amount",
            selector: (row) => `${row?.complete_total_amount} PKR`,
            // minWidth: "140px",
            tableColumn: false,
            filterName: "totalCostFilter",
            type: "number",
        },
        (canDelete) && {
            name: "Actions",
            key: "actions",
            checked: true,
            disabled: false,
            hide: false,
            exportColumn: false,
            allowOverflow: true,
            ignoreRowClick: true,
            selector: (row) => (
                <div className="table_action_btn">
                    <PermissionWrapper
                        module={MaintinaceSubModules.WorkOrders}
                        permission={WorkOrdersPermission.Delete}
                        mainModule={AppMainModules.maintenance}
                    >
                        <button onClick={() => {
                            setDeleteUserPopup(true);
                            setDeleteUserId(row?.id);
                        }} className="delete_btn">
                            <RiDeleteBinLine />
                        </button>
                    </PermissionWrapper>
                </div>
            ),
            sortable: false,
            tableColumn: false,
            minWidth: "120px",
        }
    ].filter(Boolean);

    const handleStatusClick = (e, row) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setStatusPopup({
            open: true,
            rowId: row.id,
            anchorPos: {
                x: rect.right + 8,
                y: rect.top,
                left: rect.left,
                right: rect.right,
                top: rect.top,
                bottom: rect.bottom,
            }
        });
    };

    const handleDeleteUser = async () => {
        try {
            await dispatch(deleteWorkOrder(deleteUserId)).unwrap();
            successNotify('Work Order deleted successfully');
            setDeleteUserPopup(false);
            setDeleteUserId(null);

            dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                searchFilters: searchFilters
            }));
        } catch (error) {
            errorNotify(error);
        }
    };

    const handleLimitChange = (newLimit) => {
        setCurrentPage(1);
        setLimit(newLimit);
    };

    const handleSearch = (text) => {
        setSearchText(text);
        setCurrentPage(1);
    };



    const processedResults = (workOrdersData?.results || []).map((item, idx, arr) => {
        const isLastFour = idx >= arr.length - 4;
        return { ...item, isLastFourServiceRow: isLastFour };
    });

    const handlePriorityClick = (e, row) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setPriorityPopup({
            open: true,
            rowId: row.id,
            anchorPos: {
                x: rect.right + 8,
                y: rect.top,
                left: rect.left,
                right: rect.right,
                top: rect.top,
                bottom: rect.bottom,
            }
        });
    };

    const handlePrioritySelect = async (priority, row) => {
        setTableLoading(true);
        try {
            await dispatch(updateRepairPriorityApi({ work_order_id: row.id, repair_class: priority === "Unscheduled" ? "unscheduled" : "scheduled" })).unwrap();
            await dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                search_text: searchText,
                searchFilters: searchFilters
            }));
            successNotify('Repair Class updated successfully');
            setPriorityPopup({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
        } catch (error) {
            errorNotify(error);
        } finally {
            setTableLoading(false);
        }
    };

    const handleSEClick = (e, row) => {
        const rect = e.target.getBoundingClientRect();
        setSePopup({
            open: true,
            rowId: row.id,
            anchorPos: { x: rect.right + 8, y: rect.top }
        });
        setSelectedSE(prev => ({ ...prev, [row.id]: [] }));

    };

    const handleSECheckbox = (rowId, value) => {
        setSelectedSE(prev => {
            const current = prev[rowId] || [];
            if (current.includes(value)) {
                return { ...prev, [rowId]: current.filter(v => v !== value) };
            } else if (current.length < 10) {
                return { ...prev, [rowId]: [...current, value] };
            }
            return prev;
        });
    };

    const handleSEPopupDone = async (row) => {
        setTableLoading(true);
        const selected = selectedSE[row.id] || [];
        if (!selected.length) {
            setTableLoading(false);
            return;
        }
        const links = selected.map(service_id => ({
            service_id,
            work_order_id: parseInt(row.id)
        }));
        try {
            await dispatch(workOrderLinkServiceEntry({ links })).unwrap();
            await dispatch(fetchWorkOrder({
                page: currentPage,
                limit: limit,
                search_text: searchText,
                searchFilters: searchFilters
            }));
            setSePopup({ open: false, rowId: null, anchorPos: { x: 0, y: 0 } });
            setSelectedSE(prev => ({ ...prev, [row.id]: [] }));
            successNotify('Service Entry linked successfully');
        } catch (error) {
            errorNotify(error);
        } finally {
            setTableLoading(false);
        }
    };

    const PriorityPopup = ({ row, onSelect }) => {
        return (
            <TablePopover
                innerRef={popupRef}
                anchorRect={priorityPopup.anchorPos}
                popupHeight={120}
                popupWidth={160}
                align="right"
            >
                {updateRepairPriorityLoading && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.6)",
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "not-allowed"
                        }}
                    >
                        <span style={{ color: "#4014B8", fontWeight: 600 }}>Updating...</span>
                    </div>
                )}

                <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
                    {repairPriorityOptions.map((priority) => (
                        <div key={priority.value} onClick={() => onSelect(priority?.value, row)}
                            style={{ display: "flex", alignItems: "center", padding: "7px", gap: "10px", backgroundColor: row.priority === priority?.value ? 'rgb(156 159 201 / 15%)' : "transparent" }}>
                            <div className={`priority ${priority?.value}`}>

                                <div className='d-flex align-items-center gap-1'>
                                    {
                                        priority?.value === 'Unscheduled' ? unscheduledIcon : scheduledIcon
                                    }
                                    {priority?.label}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </TablePopover>
        );
    }

    const AddSEPopup = ({ selected, onCheck, onDone, row, index }) => {
        const windowHeight = document.documentElement.clientHeight;
        const popupHeight = 160;

        const availableSpaceAbove = index * popupHeight;
        const availableSpaceBelow = windowHeight - (availableSpaceAbove + popupHeight);

        let positionStyle = {};
        if (availableSpaceBelow > availableSpaceAbove) {
            positionStyle = { top: "0px" };
        } else {
            positionStyle = { bottom: "0px" };
        }

        return (
            <div
                ref={sePopupRef}
                style={{
                    position: "absolute",
                    left: "70px",
                    background: "#FAF9FB",
                    border: "1px solid #D1D2E0",
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 4,
                    padding: "5px 0 4px 0",
                    minWidth: "200px",
                    // width: "200px",
                    ...positionStyle
                }}
            >
                <div style={{ padding: "0 8px 2px 8px", fontWeight: 600, fontSize: 13, color: "#3D3F5C", display: "flex", justifyContent: "space-between" }}>
                    <span>Selected</span>
                    <span style={{ fontWeight: 500 }}>{selected.length}/{row?.vehicle_services.length}</span>
                </div>
                <div style={{ maxHeight: 105, overflowY: "auto", padding: "0 0px 0 0px" }}>
                    {
                        row?.vehicle_services.length === 0 && (
                            <div style={{ padding: "8px", textAlign: "center", color: "#B4B4C6" }}>No SE Available</div>
                        )
                    }
                    {row?.vehicle_services.map(opt => (
                        <div key={opt.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 8px" }}>
                            <input
                                type="checkbox"
                                checked={selected.includes(opt.id)}
                                onChange={() => onCheck(row.id, opt.id)}
                                disabled={!selected.includes(opt.id) && selected.length >= 10}
                                style={{ accentColor: "#4014B8", cursor: "pointer" }}
                            />
                            <span style={{ fontSize: 14, color: "#3D3F5C" }}>{opt.service_id}</span>
                        </div>
                    ))}
                </div>
                {
                    row?.vehicle_services.length > 0 &&
                    <div style={{ padding: "0px 5px 0 5px" }}>
                        <button
                            style={{
                                width: "100%",
                                background: selected.length > 0 ? "#4014B8" : "#E5E5F2",
                                color: selected.length > 0 ? "#fff" : "#B4B4C6",
                                border: "none",
                                borderRadius: "6px",
                                padding: "4px 0",
                                fontWeight: 600,
                                fontSize: 14,
                                cursor: selected.length > 0 ? "pointer" : "not-allowed"
                            }}
                            disabled={selected.length === 0 || createLinkIssueLoading}
                            onClick={() => onDone(row)}
                        >
                            {createLinkIssueLoading ? 'Loading...' : "Done"}
                        </button>
                    </div>
                }
            </div>
        )
    }

    const handleUserMouseEnter = (e, row, type) => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }

        // if (hoveredUser.locked && hoveredUser.rowId === row.id && hoveredUser.type === type) return;
        const rect = e.currentTarget.getBoundingClientRect();

        if (!showModal) {
            setHoveredUser({
                show: true,
                rowId: row.id,
                type,
                anchorPos: {
                    x: rect.right + 6,
                    y: rect.bottom + 6,
                    left: rect.left,
                    right: rect.right,
                    top: rect.top,
                    bottom: rect.bottom,
                },
                locked: false
            });
        }
    };

    const handleUserMouseLeave = () => {
        if (hoveredUser.locked) return;

        hoverTimeoutRef.current = setTimeout(() => {
            if (!showModal) {
                setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false });
            }
        }, 1500);

    };

    const handleUserClick = (e, row, type) => {
        e.stopPropagation();
        if (hoveredUser.locked && hoveredUser.rowId === row.id && hoveredUser.type === type) {
            setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false });
        } else {
            const rect = e.currentTarget.getBoundingClientRect();

            if (!showModal) {
                setHoveredUser({
                    show: true,
                    rowId: row.id,
                    type,
                    anchorPos: {
                        x: rect.right + 6,
                        y: rect.bottom + 6,
                        left: rect.left,
                        right: rect.right,
                        top: rect.top,
                        bottom: rect.bottom,
                    },
                    locked: true
                });
            }
        }
    };

    const handleCardMouseEnter = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    }

    const handleCardMouseLeave = () => {
        if (!showModal) {
            setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false });
        }
        // setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false });
    };

    const UserDropdown = ({ users, onSelect, row, dropdownRef }) => {
        return (
            <div
                ref={dropdownRef}
                style={{
                    position: "relative",
                    background: "rgb(250, 249, 251)",
                    border: "1px solid #E0E0E0",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                    zIndex: 4,
                    width: "160px",
                    padding: "8px 0",
                }}
            >
                {updateVendorLoading && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.6)",
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "not-allowed"
                        }}
                    >
                        <span style={{ color: "#4014B8", fontWeight: 600 }}>Updating...</span>
                    </div>
                )}
                <div className='vendor_dropdown'>
                    {getVendorsDropdownData.map((user, idx) => (
                        <div
                            key={user.value}
                            onClick={updateVendorLoading ? () => { } : () => onSelect(user.value, row)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "4px 8px",
                                cursor: updateVendorLoading ? "not-allowed" : "pointer",
                                background: row?.vendor?.id === user.value ? "#fff" : "rgb(250, 249, 251)"
                            }}
                        >
                            <span style={{ fontSize: 14, color: "#3D3F5C" }}>{user.title}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const AssigneeDropdown = ({ users, onSelect, row, dropdownRef }) => {
        return (
            <div
                ref={dropdownRef}
                style={{
                    position: "relative",
                    background: "rgb(250, 249, 251)",
                    border: "1px solid #E0E0E0",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                    zIndex: 4,
                    width: "230px",
                    padding: "8px 0",
                }}
            >
                {/* Overlay when loading */}
                {updateWorkOrderAssigneeLoading && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.6)",
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "not-allowed"
                        }}
                    >
                        <span style={{ color: "#4014B8", fontWeight: 600 }}>Updating...</span>
                    </div>
                )}
                <div style={{ maxHeight: 150, overflowY: "auto" }}>
                    {users?.map((user, idx) => (
                        <div
                            key={user.value}
                            onClick={updateWorkOrderAssigneeLoading ? () => { } : () => onSelect(user.value, row)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "2px 8px",
                                cursor: updateWorkOrderAssigneeLoading ? "not-allowed" : "pointer",
                                background: row?.assignee?.id === user.value ? "#fff" : "rgb(250, 249, 251)"
                            }}
                        >
                            <UserAvatar username={user.label} image={user.image} marginRight={"5px"} />
                            <span style={{ fontSize: 14, color: "#3D3F5C" }}>{user.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const StatusPopup = ({ row, onSelect }) => {
        return (
            <TablePopover
                innerRef={statusPopupRef}
                anchorRect={statusPopup.anchorPos}
                popupHeight={125}
            >

                {updateWorkOrderStatusLoading && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.6)",
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "not-allowed"
                        }}
                    >
                        <span style={{ color: "#4014B8", fontWeight: 600 }}>Updating...</span>
                    </div>
                )}

                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    {approvalStatusOptions.map((status) => (
                        <div key={status.value}
                            style={{ display: "flex", alignItems: "center", padding: "5px 5px", gap: "10px", justifyContent: "center", backgroundColor: row.status === status?.value ? 'rgb(156 159 201 / 15%)' : "transparent" }}>
                            <div
                                className={`status ${status.value}`}
                                onClick={() => onSelect(status.value, row)}
                                style={{ cursor: "pointer", textTransform: "capitalize" }}>
                                <div className='d-flex align-items-center gap-1'>
                                    {status.value === "open" ? openIcon : status.value === "closed" ? closedIcon : status.value === "approved" ? resolvedIcon : status.value === "resolved" ? resolvedIcon : status.value === "completed" ? resolvedIcon : status.value === "in_progress" ? inProgressIcon : null}
                                    {status.label}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </TablePopover>
        )
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (!event.target.closest('.hyperlink')) {
                if (!showModal) {
                    setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false });
                }
            }
        }
        if (hoveredUser.show && hoveredUser.locked) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [hoveredUser.show, hoveredUser.locked]);



    return (
        <div>

            <Breadcrumbs values={['Work Order', 'Overview']} />

            <CustomModal heading="Create Work Order" size="lg" show={showCreateIssuePopup} handleClose={() => setShowCreateIssuePopup(false)}>
                <CreateWorkOrder onClose={() => setShowCreateIssuePopup(false)}
                    searchText={searchText} searchFilters={searchFilters}
                    currentPage={currentPage} limit={limit}
                />
            </CustomModal>

            <CustomModal show={deleteUserPopup} handleClose={() => setDeleteUserPopup(false)} size="md" heading="Delete Work Order" customHeaderCss="custom_header_css">
                <div className="delete_user_modal_body">
                    <p>Are you sure you want to delete this Work Order?</p>

                    <Button
                        cancelBtn={() => setDeleteUserPopup(false)}
                        submitBtn={handleDeleteUser}
                        loading={deleteWorkOrderLoading}
                        disabled={deleteWorkOrderLoading}
                        buttonExtraCss="delete_user_modal_btn"
                        submitText="Delete"
                        type="submit"
                    />
                </div>
            </CustomModal>

            <div className='access_view'>
                <h2>Overview</h2>

                <div className='services_buttons'>
                    <Notification />

                    {canExport && (
                        <>
                            <ExportButton
                                type="pdf"
                                onClick={handleExportPdf}
                                disabled={!hasActiveFilters || exportLoading}
                                loading={pdfExportLoading}
                                hasActiveFilters={hasActiveFilters}
                            />

                            <ExportButton
                                type="excel"
                                onClick={handleExportExcel}
                                disabled={!hasActiveFilters || exportLoading}
                                loading={excelExportLoading}
                                hasActiveFilters={hasActiveFilters}
                            />
                        </>
                    )}
                    <PermissionWrapper
                        module={MaintinaceSubModules.WorkOrders}
                        permission={WorkOrdersPermission.Create}
                        mainModule={AppMainModules.maintenance}
                    >
                        <button onClick={() => setShowCreateIssuePopup(true)}>{plusIcon} Add Work Order</button>
                    </PermissionWrapper>
                </div>
            </div>

            <WorkOrdersChart />

            <NewTableComponent
                showAddBtn={false}
                columns={columns}
                data={processedResults}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                limit={limit}
                setLimit={handleLimitChange}
                totalItems={workOrdersData?.meta?.totalItems}
                totalPages={workOrdersData?.meta?.totalPages}
                onSearch={handleSearch}
                loading={tableLoading ? false : workOrdersLoading}
                setSearchFilters={setSearchFilters}
                searchFilters={searchFilters}
                paginationLoading={tableLoading ? false : workOrdersLoading}
                tableClassName="maintenance_hover_table"
            />
        </div>
    )
}

export default WorkOrders;
